import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';

import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

class TableTelefonos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            telefonos: [],
            selectedRow: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.telefonos != this.props.telefonos) {
            this.setState({ telefonos: this.props.telefonos });
        }
    }

    onChange = data => {
        this.setState(
            prevState => ({
                telefonos: prevState.telefonos.concat(data)
            }),
            () => {
                if (this.props.onChange) this.props.onChange(this.state.telefonos)
            }
        );
    }

    onDelete = row => {
        this.setState(
            prevState => {
                prevState.telefonos.splice(row, 1);
                return {
                    telefonos: prevState.telefonos,
                    selectedRow: null
                }
            },
            () => {
                if (this.props.onChange) this.props.onChange(this.state.telefonos)
            }
        );
    }

    onEdit = (data, row) => {
        this.setState(
            prevState => {
                prevState.telefonos[row] = data;
                return {
                    telefonos: prevState.telefonos,
                    selectedRow: null
                }
            },
            () => {
                if (this.props.onChange) this.props.onChange(this.state.telefonos);
            }
        );
    }
    
    render() {
        const { telefonos, selectedRow } = this.state;
        const { action } = this.props;
        return (
            <div className="ui-contact-table">
                { (action === 'CREATE' || action === 'EDIT') &&
                    <Fragment>
                        <ModalTelefonos
                            onChange={this.onChange}
                            action="create"
                        />
                        <ModalTelefonos
                            onEdit={this.onEdit}
                            value={telefonos[selectedRow]}
                            row={selectedRow}
                            action="edit"
                        />
                    </Fragment>
                }
                <ModalTelefonos
                    value={telefonos[selectedRow]}
                    row={selectedRow}
                    action="detail"
                />
                { (action === 'CREATE' || action === 'EDIT') &&
                    <ModalTelefonos
                        onDelete={this.onDelete}
                        value={telefonos[selectedRow]}
                        row={selectedRow}
                        action="delete"
                    />
                }
                <Table size="sm" className="ui-contact-table-grid">
                    <thead>
                        <tr>
                            <th>Teléfono</th>
                        </tr>
                    </thead>
                    <tbody>
                        { telefonos.map(
                            (telefono, i) => 
                                <tr
                                    key={i}
                                    className={selectedRow === i ? 'is-selected' : ''}
                                    onClick={() => this.setState(prevState => ({
                                        selectedRow: prevState.selectedRow === i ? null : i
                                    }))}
                                >
                                    <td>{telefono.telefono}</td>
                                </tr>
                            )
                        }
                        { telefonos.length === 0 && 
                            <tr>
                                <td className="text-center ui-contact-table-empty" colSpan={3}>No hay teléfonos</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        );
    }
}

class ModalTelefonos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            telefono: '',
            descripcion: '',
            isOpen: false
        }
    }

    static propTypes = {
        action: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        disabled: PropTypes.bool
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                id: nextProps.value.id,
                telefono: nextProps.value.telefono,
                descripcion: nextProps.value.descripcion
            });
        }
    }

    actionData = {
        delete: {
            icon: 'fa fa-minus',
            color: 'danger',
            title: 'Eliminar teléfono',
            button: 'Eliminar',
            disabled: true,
            buttonColor: 'danger'
        },
        create: {
            icon: 'fa fa-plus',
            color: 'secondary',
            title: 'Agregar teléfono',
            button: 'Agregar',
            disabled: false,
            buttonColor: 'success'
        },
        detail: {
            icon: 'fa fa-search',
            color: 'secondary',
            title: 'Ver teléfono',
            button: false,
            disabled: true
        },
        edit: {
            icon: 'fa fa-pencil',
            color: 'secondary',
            title: 'Editar teléfono',
            button: 'Guardar',
            disabled: false,
            buttonColor: 'success'
        }
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    close = () => {
        if (this.props.action === 'create') {
            this.setState({
                id: undefined,
                telefono: '',
                descripcion: '',
            });
        }
        this.toggle();
    }

    onChangeField = (field, value) => {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    onSubmit = () => {
        const { action, row } = this.props;
        const { telefono, descripcion, id } = this.state;
        if (action === 'create') {
            if (telefono) {
                this.props.onChange({ telefono, descripcion });
                this.close();
            } else {
                this.setState({ errors: { telefono: [{detail: 'Debe ingresar un teléfono.'}] } });
            }
        } else if (action === 'edit') {
            if (telefono) {
                this.props.onEdit({ telefono, descripcion, id }, row);
                this.close();
            } else {
                this.setState({ errors: { telefono: [{detail: 'Debe ingresar un teléfono.'}] } });
            }
        } else if (action === 'delete') {
            this.props.onDelete(row);
            this.close();
        }
    }
    
    render() {
        const { isOpen } = this.state;
        const { action, disabled, row } = this.props;
        const actionData = this.actionData[action];
        return (
            <Fragment>
                { !disabled && 
                    <Button
                        color={actionData['color']}
                        onClick={this.toggle}
                        size="sm"
                        className="mr-1 btn-table-modal rounded"
                        disabled={(action === 'detail' || action === 'delete' || action === 'edit') && (row === null)}
                    >
                        <i className={actionData['icon']} aria-hidden="true"></i>
                    </Button>
                }

                <Modal isOpen={isOpen} toggle={this.toggle} className={"ui-paradigma-modal" + (action === 'delete' ? " modal-danger" : "")}>
                    <ModalHeader toggle={this.toggle}>
                        { actionData['title'] }
                    </ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos del teléfono</p>
                            <div className="ui-form-stack">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Teléfono"}
                                    error={this.state.errors && this.state.errors.telefono}
                                    inputComponent={
                                        <Input
                                            disabled={actionData['disabled']}
                                            maxLength={50}
                                            value={this.state.telefono}
                                            onChange={e => {
                                                e.persist();
                                                this.setState(prevState => ({
                                                    telefono: /^\d*$/.test(e.target.value) ? e.target.value : prevState.telefono,
                                                    errors: {}
                                                }));
                                            }}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    disabled={actionData['disabled']}
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Descripción"}
                                    type="textarea"
                                    value={this.state.descripcion}
                                    onChange={e => this.onChangeField('descripcion', e.target.value)}
                                />
                            </div>
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Cancelar</Button>
                        { actionData['button'] && 
                            <Button color={actionData['buttonColor']} onClick={this.onSubmit} className="mr-1">
                                {actionData['button']}
                            </Button>
                        }
                    </ModalFooter>
                </Modal>

            </Fragment>
        );
    }
}

export default TableTelefonos;



// WEBPACK FOOTER //
// ./src/views/Clientes/TableTelefonos.js